import { Component, OnInit, ViewContainerRef, ViewChild } from '@angular/core';
import { CapacityModelService } from "./../services/CapacityModel-Service";
import { ResponseMsg } from "./../common/response-message";
import { ActivatedRoute, Router } from "@angular/router";
import { ValidateDataService } from "./../services/validate-data.service";
import { StaffSecurityRoleData, UploadRequestModel, UploadResponseModel } from "./../models/cm-model";
import { AuthHelper } from './../services/authHelper';
import {
  SohoModalDialogService, SohoBusyIndicatorDirective,
  SohoMessageRef, SohoNotificationService, SohoFileUploadComponent
} from "ids-enterprise-ng";
import { DatePipe } from '@angular/common';
import { UserData } from '../shared/models/user.model';
import { Injectable } from '@angular/core';

@Component({
  selector: 'app-access-controller',
  templateUrl: './access-controller.component.html',
  styleUrls: ['./access-controller.component.css'],
  providers: [DatePipe]
})
@Injectable({
  providedIn: 'root'
})
export class AccessControllerComponent implements OnInit {
  dialog!: SohoMessageRef;
  @ViewChild(SohoBusyIndicatorDirective, { static: true }) busyIndicator?: SohoBusyIndicatorDirective;
  @ViewChild(SohoFileUploadComponent, { static: true }) fileupload?: SohoFileUploadComponent;
  placeholder!: ViewContainerRef;
 
  isvalid!: boolean;
  public getTodaysDate!: Date;
  public getDate?: string;
  emailAddress!: string;
  userData = new UserData();
  message = 'Uploading...';
  delay = 5;
  transparentOverlay = true;
  staffid: number = 0;

  public ObjResponse: any;

  public UploadTypeToolTip = ResponseMsg.UploadTypeToolTip;
  public ProjectTitle = "UserAccessDetails";
  
  

  constructor(private capacityModelService: CapacityModelService,
    private validateService: ValidateDataService,
    public model:StaffSecurityRoleData,
    public responsemodel: StaffSecurityRoleData,
    private modalDialog: SohoModalDialogService,
    private router: Router,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private authhelper: AuthHelper,
    private notificationService: SohoNotificationService) { }

    ngOnInit(): void {
      Soho.Locale.set('en-US');
      this.showNotification();
      if(this.route)
      {
      this.route.queryParams.subscribe(params => {       
        this.staffid = params["staffid"];
      });
      }
        this.userData = JSON.parse(localStorage.getItem("userprofile")!);
        if (this.userData != null && this.userData != undefined) {
          this.emailAddress = this.userData.Email;
          this.UploadDetails();
        }
    }
    showNotification() {
      this.notificationService.show({
        parent: "#notification",
        message:
          "This page is used to upload data.",
        type: "info",
        linkText: "",
        link: "",
      });
      this.getTodaysDate = new Date();
      this.getDate = this.datePipe.transform(new Date(), 'MM/dd/yyyy')!;
      //$("#btnBusy").trigger('click');
    }
    start() {
      (this.busyIndicator as any).activated = true;
    }
  
    stop() {
      (this.busyIndicator as any).activated = false;
    }
    LoadBusyIndicator() {
      (this.busyIndicator as any).activated = true;
      setTimeout((_f: any) => (this.busyIndicator as any).activated = false, 20000);
    }
    CloseBusyIndicator() {
      (this.busyIndicator as any).activated = false;
    }
    RemoveError(id: string) {
      $("#" + id).removeMessage().removeError();
    }
    ShowErrorAlert(Message: string, Title: string) {
      const dialogRef1 = this.modalDialog
        .message("<h2>" + Message + "</h2>")
        .buttons(
          [
            {
              text: 'Ok', click: () => {
                dialogRef1.close('Ok');
              }, isDefault: true
            }
          ])
        .title(Title)
        .open()
        .frameHeight(1000);
    }
  
    ShowAlert(Message: string, Title: string) {
      const dialogRef1 = this.modalDialog
        .message("<h2>" + Message + "</h2>")
        .buttons(
          [
            {
              text: 'Ok', click: () => {
                dialogRef1.close('Ok');
                this.ResetModel();
              }, isDefault: true
            }
          ])
        .title(Title)
        .open()
        .frameHeight(1000);
    }
    ResetModel() {
      let fields: string[] = [
        "emailaddress"
        
      ];
      for (let objField of fields) {
        $("#" + objField).removeError();
      }
      this.model.emailaddress ="";
      this.model.securityroleid = 0;
      this.model.createdby="";
      //this.model.uniqueid=0;
      
    }
  
    UploadDetails() {
      this.model.createdby = this.emailAddress == null ? "satyanarayana.pagidoju@infor.com" : this.emailAddress;
      this.isvalid = true;
      let errorFields: string[];
      errorFields = [];
      errorFields = this.validateService.validateFormFields(this.model, ["emailaddress"]);
  
      if (errorFields.length > 0) {
        for (let objField of errorFields) {
          $("#" + objField)
            .removeError()
            .addError({ message: ResponseMsg.Required, showTooltip: true });
          this.isvalid = false;
        }
      }
      if (this.isvalid) {
       
        this.start();
        this.capacityModelService.CrateApplicationAccess(this.model).subscribe(
          response => {
            this.stop();
        
            if (response.Status == 200) {
             
              this.ShowAlert("User details updated successfully.", ResponseMsg.Success);
            } else {
              
              this.ShowAlert("Error occured", ResponseMsg.ErrorMsg);
            }
          },
          (error: Response) => {
            this.stop();
            this.AddErrorDetails(error);
            this.ShowAlert("Error Occured while updating user details / Plese check HMD ID.", ResponseMsg.ErrorMsg);
          }
        );
      }      
     }
   // }
   AddErrorDetails(error: Response) {
      
    }
    

}
